import React, { useState, useEffect } from 'react';
import { Alert, IconButton, Collapse, Typography, Link } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Optional: for an icon in the alert

const LOCAL_STORAGE_KEY = 'followInfoBannerDismissed_v1'; // Increment version if content changes significantly

const FollowInfoBanner = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        // Check if the banner was dismissed previously
        const dismissed = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!dismissed) {
            setOpen(true);
        }
    }, []);

    const handleClose = () => {
        setOpen(false);
        // Mark as dismissed so it doesn't show again
        localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
    };

    if (!open) {
        return null;
    }

    return (
        <Collapse in={open} sx={{ mb: 2 }}>
            <Alert
                severity="info"
                iconMapping={{
                    info: <InfoOutlinedIcon fontSize="inherit" />,
                }}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={handleClose}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{
                    '.MuiAlert-message': {
                        width: '100%', // Ensure message takes full width for better layout
                    },
                }}
            >
                <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                    Track Cases with "Follow" & Get Notified!
                </Typography>
                <Typography variant="body2" component="div">
                    Use the "Follow Case" feature to keep an eye on specific timelines.
                    <ul>
                        <li>
                            <strong>Web Followers:</strong> We check for updates on your followed timelines every 3 days and will try to send you an email if there are changes.
                        </li>
                        <li>
                            <strong>Mobile App Users:</strong> For more immediate updates, download our mobile app available on <Link href="https://apps.apple.com/ca/app/track-copr-canada/id6748865450" target="_blank" rel="noopener">iOS</Link> (Android is awaiting Google approval). You may receive mobile notifications for changes to timelines you follow.
                        </li>
                    </ul>
                    This helps me to manage server resources while keeping you informed.
                </Typography>
            </Alert>
        </Collapse>
    );
};

export default FollowInfoBanner;